import { MAX_PANEL_HEIGHT as e } from "../constants/index.mjs";
const g = (o, n) => {
  let t = 0;
  return o && (o.querySelectorAll('[role="option"]').forEach((i) => {
    t += i.getBoundingClientRect().height;
  }), t = n ? Math.min(t, e) || e : 42), t;
};
export {
  g as getPanelHeight
};
